import React, {Component} from "react";
import Header from "../../../Containers/Header/Header";
import Footer from "../../../Containers/Footer";
import PageTopMenu from "../../../Containers/PageTopMenu";
import VocabHomeworkPage from "../Vocab/Homework";
import Loading from "../../../Containers/Loading";

class VocabHomework extends Component {

    state = {
        // loading
        isLoadingHide: false
    }

    componentDidMount = () => {
        this.setState({
            isLoadingHide: true
        });
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        return (
            <div className="beaconWrapper">
                <Header />
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <h2 className="screenOut">오늘의 Vocabulary 숙제</h2>
                        <PageTopMenu onClick={() => {
                            this.props.history.goBack()
                        }}/>
                        <div className="pageContents">
                            <VocabHomeworkPage categoryName="vocabulary"/>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default VocabHomework;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Homework/VocabHomework.js